<div class="sidebar-next-right-block main-merchant layout-location root-body-sidebar-slim custom-w">
    <div class="title-header mb-4">Finance</div>
    <mat-tab-group mat-stretch-tabs="false">
        <mat-tab label="Reports">
            <ng-template matTabContent>
                <partner-finance-reports></partner-finance-reports>
            </ng-template>
        </mat-tab>
        <mat-tab label="Settlement Reports">
            <ng-template matTabContent>
                <partner-finance-settlement-reports></partner-finance-settlement-reports>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</div>

<p-toast position="top-right"></p-toast>
